export default "__VITE_ASSET__595e1e6c__"